export default __webpack_public_path__ + "static/media/element_spec_65.3b1db922.webp";